import styled, { css } from 'styled-components';
import {
  getColor,
  getTransition,
  getSpace,
  getGridSpan,
  getGridSpans,
  mq
} from '../../../stylesheets/tools';

const StyledHeroTeaser = styled.div`
  position: relative;
  margin: ${getSpace('l')} 0;
  overflow: hidden;

  ${mq('m')} {
    .heroTeaser__header {
      width: ${props => (props.isEvent ? getGridSpan(9) : getGridSpan(10))};
      position: relative;
      left: ${props => (props.isEvent ? getGridSpan(3, 'spread') : getGridSpan(2, 'spread'))};
    }
  }

  .heroTeaser__tags {
    margin-bottom: 15px;
  }

  .heroTeaser__categories {
    padding-bottom: ${getSpace('l')};
    margin-left: ${({ digitalContent }) => digitalContent && '78px'};
  }

  .heroTeaser__headlines {
    margin-right: ${props =>
      props.isEvent ? getGridSpan(1, 'spread', 9) : getGridSpan(1, 'spread', 10)};
    display: flex;
  }

  .heroTeaser__headline {
    padding-bottom: 20px;
  }

  .heroTeaser__icon {
    flex-shrink: 0;
    margin-right: ${getSpace('xs')};
    fill: #000;
    color: ${props =>
      props.theme.siteTheme.primary !== '#fff' ? props.theme.siteTheme.primary : '#000'};
  }

  .heroTeaser__image-wrapper {
    position: relative;
    left: ${getGridSpan(1, 'spread')};
    padding-bottom: calc(3 / 4 * 100%);
    height: 0;
    background: ${getColor('lightGray')};
    animation: loadingBg 1s linear infinite alternate;
    width: 100%;

    ${mq('m')} {
      padding-bottom: 56.25%;
    }
  }

  .heroTeaser__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    outline: none;
    border: none;
  }

  .heroTeaser__date {
    position: absolute;
    bottom: -50px;
    left: ${getGridSpan(-1, 'spread')};

    ${mq('m')} {
      bottom: -60px;
      margin-left: 35px;
    }
  }

  .heroTeaser__content {
    padding-top: ${getSpace('s')};
  }

  .heroTeaser__text {
    ${getGridSpans('width', { s: 11, m: 8 })}

    ${mq('m')} {
      margin-left: ${props =>
        props.isEvent ? getGridSpan(3, 'spread') : getGridSpan(2, 'spread')};
    }

    ${props =>
      props.period &&
      props.isEvent &&
      props.hasImage &&
      css`
        ${getGridSpans('margin-left', { m: [5, 'spread'], l: [4, 'spread'] })}
        ${getGridSpans('width', { m: 7 })}
      `};

    ${props =>
      props.isEvent &&
      props.hasImage &&
      css`
        margin-top: 80px;
        ${mq('m')} {
          margin-top: 0;
        }
      `};
  }

  .heroTeaser__arrow {
    svg {
      width: 38px;
    }

    ${mq('m')} {
      opacity: 0;
      ${getTransition('fadeFast')}
    }
  }

  &:hover {
    .heroTeaser__arrow {
      opacity: 1;
    }
  }

  ${props =>
    !props.isEvent &&
    !props.hasImage &&
    css`
      .heroTeaser__link {
        padding-top: 50px;

        ${mq('m')} {
          padding-top: 60px;

          .heroTeaser__headline {
            width: ${getGridSpan(9)};
          }
        }
      }

      .heroTeaser__link:before {
        position: absolute;
        content: '';
        height: 3px;
        background: #000;
        top: 0;
        left: 0;
        ${getGridSpans('left', { m: [1, 'spread'] })}
        ${getGridSpans('width', { s: [13, 'spread'], m: [7, 'spread'] })}
      }
    `}

  ${props =>
    props.isEvent &&
    !props.hasImage &&
    css`
      position: relative;

      .heroTeaser__content {
        width: ${getGridSpan(11)};
        padding: 30px;
        margin-left: ${getGridSpan(1, 'spread')};
        border: 1px solid #000;
        padding-top: ${getSpace('s')};
        border-radius: 8px;

        ${mq('l')} {
          padding: 75px;
        }
      }

      .heroTeaser__date {
        bottom: auto;
        top: 75px;
      }

      .heroTeaser__header,
      .heroTeaser__text {
        width: auto;
        left: auto;

        ${mq('m')} {
          margin-left: ${date =>
            date.period ? getGridSpan(3, 'normal') : getGridSpan(1, 'normal')};
        }
      }

      .heroTeaser__headline,
      .heroTeaser__subline {
        width: auto;
      }

      .heroTeaser__categories {
        margin-bottom: 150px;

        ${mq('l')} {
          margin-bottom: 0;
        }
      }
    `}
`;

export default StyledHeroTeaser;
